import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

// slices
import {
    clearPendingWidgetRedirect,
    isUserAuthenticated,
    loginState,
} from '../login/login.slice'

// routes
import { PRIVATE_ROUTES } from '../../routes'

// helpers
import { getNavigateTargetFromWidgetRedirect } from '../../helpers/widgetRedirect'

const WidgetRedirectNavigate = ({ to }) => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(clearPendingWidgetRedirect())
    }, [dispatch])

    return <Navigate to={to} replace />
}

// PUBLIC ROUTES
const PublicRoute = () => {
    const { userProfile, status, pendingWidgetRedirect } = useSelector(loginState)

    if (status !== 'loading' && isUserAuthenticated(userProfile)) {
        const widgetTarget = getNavigateTargetFromWidgetRedirect(
            pendingWidgetRedirect
        )
        if (widgetTarget) {
            return <WidgetRedirectNavigate to={widgetTarget} />
        }

        if (userProfile?.isSupportUser) {
            if (userProfile?.isSuperAdmin) {
                return <Navigate to={`${PRIVATE_ROUTES.clients}`} />
            } else {
                return (
                    <Navigate
                        to={`${PRIVATE_ROUTES.projects.projectId(
                            Object.keys(userProfile?.activeProjectId).length > 0
                                ? userProfile?.activeProjectId?._id
                                : null
                        )}`}
                    />
                )
            }
        } else if (userProfile?.activeProject === null) {
            return <Navigate to={`${PRIVATE_ROUTES.projects.root}`} />
        }
    }

    return <Outlet />
}

export default PublicRoute
